var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},'a',{ href: _vm.href, style: _vm.style },false),[_vm._t("default",null,null,{ time: _vm.timeLeft })],2)}
var staticRenderFns = []

export { render, staticRenderFns }